import api from "../../config/APIConfig";

const { iAxios, apiUri } = api;
const baseUrl = `${apiUri}`;

export const SessionActions = {
  login,
  ValidaToken,
  logout,
  getCurrentUser,
  traerEtapa,
  finalizar,
  TraerDatosUsuario,
  generarToken,
  validarCliente,
  personaCertificados,
  getContract,
  postContract,
};
function login(token) {
  const UserSolicitud = {};
  //...fill your object like this for example
  //crear session con los datos del response
  UserSolicitud["Token"] = token;
  return iAxios.post(`${baseUrl}/Login`, UserSolicitud).then((response) => {
    if (response !== undefined) {
      localStorage.setItem("currentUser", JSON.stringify(response.data));
      iAxios.defaults.headers.common["Authorization"] =
        "Bearer " + response.data;
      return true;
    } else {
      alert("Error al validar credenciales");
      return false;
    }
  });
}
function ValidaToken(token) {
  const UserSolicitud = {};
  UserSolicitud["Token"] = token;
  return iAxios.post(`${baseUrl}/ValidaToken`, UserSolicitud);
}
function finalizar(token) {
  return iAxios.get(`${baseUrl}/FAO/Finalizar?Token=` + token);
}
function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("currentUser");
}

function getCurrentUser() {
  return JSON.parse(localStorage.getItem("currentUser"));
}
function traerEtapa(token) {
  return iAxios.get(`${baseUrl}/etapa?token=` + token);
}
async function getContract(token) {
  const res = await iAxios.get(`${baseUrl}/contrato?Token=${token}`);

  if (res.status != 200) {
    return false;
  }
  return res?.data;
}

async function postContract(token) {
  const res = await iAxios.post(`${baseUrl}/contrato`, { Token: token });
  if (res.status != 200) {
    return false;
  }
  return res.data;
}

function TraerDatosUsuario(token) {
  return iAxios.get(`${baseUrl}/FAO/TraerDatosUsuario?token=` + token);
}

function generarToken(codigoFujo) {
  return iAxios.get(`${baseUrl}/FAO/generarToken?codigoFujo=` + codigoFujo, {
    headers: { sitePath: document.URL },
  });
}
function validarCliente(token, run, email) {
  return iAxios.get(
    `${baseUrl}/v1/validarCliente?token=` +
      token +
      "&run=" +
      run +
      "&email=" +
      email
  );
}
function personaCertificados(token, run, email) {
  return iAxios.get(
    `${baseUrl}/v1/personaCertificados?token=` +
      token +
      "&run=" +
      run +
      "&email=" +
      email
  );
}
